// removed by extract-text-webpack-plugin
module.exports = {"root":"_3xULi","list":"_2VTUK","link":"_3-r-g"};


//////////////////
// WEBPACK FOOTER
// ../source/components/LinkNav/styles.css
// module id = 1229
// module chunks = 26